module.exports = __webpack_public_path__ + "statics/img/icon-ad1.175203ef.png";